
import yotpoWidgetMixin from "~/mixins/yotpoWidgetMixin";

export default {
  mixins: [yotpoWidgetMixin],
  props: {
    productId: {
      type: [String, Number],
      required: true,
    },
  },
};
